import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { css } from '@emotion/react';
import { theme } from 'styles/theme';
import { ButtonCircleStyle } from 'styles/ButtonCircleStyle';
import { AnimationFadeIn, AnimationSlideUp } from 'styles/animations';
import { FlexStyle } from 'styles/FlexStyles';
import { IconCross } from 'icons/icon-cross';

export const Modal = ({
	width,
	close,
	isOpen,
	children,
}: {
	width?: number;
	close: () => void;
	isOpen: boolean;
	children: ReactNode;
}) => {
	const targetEl = document.getElementById('modal-root') as HTMLElement;

	return (
		<>
			{isOpen &&
				ReactDOM.createPortal(
					<div css={ModalBackdropStyle()}>
						<div css={ModalContentStyle({ width: width })}>
							<button
								css={[ButtonCircleStyle({ sizeSmall: true }), ModalCloseButtonStyle()]}
								onClick={() => close()}
							>
								<IconCross />
							</button>

							{children}
						</div>
					</div>,
					targetEl,
				)}
		</>
	);
};

const ModalBackdropStyle = () => [
	FlexStyle({ centered: true, full: true }),
	css`
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 9200;
		animation: ${AnimationFadeIn()} 0.2s ease;
	`,
];

const ModalContentStyle = ({ width }: { width?: number }) => css`
	width: ${width || 320}px;
	animation: ${AnimationSlideUp()} 0.3s ease;
	position: relative;
	background: #fff;
	box-shadow: 0 20px 32px -8px rgba(0, 0, 0, 0.15), 0 0 1px 0 rgba(0, 0, 0, 0.3);
	border-radius: 12px;
	overflow: hidden;
`;

const ModalCloseButtonStyle = () => css`
	position: absolute;
	top: 12px;
	right: 12px;
	color: ${theme.color.text[300]};
	&:hover {
		cursor: pointer;
	}
`;
